import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import { Select } from "components/common/Select";
import type { RouteGroupSelectionStepV3Props } from "./types";

export const RouteGroupSelectionStepV3 = ({
  selectedRouteTypeName,
  onRouteTypeNameChange,
  routeTypeOptions,
  onStartDrawing,
}: RouteGroupSelectionStepV3Props) => {
  const { t } = useTranslation();

  const isRouteTypeSelected = selectedRouteTypeName.trim().length > 0;

  const selectOptions = useMemo(
    () => routeTypeOptions.map((option) => ({ value: option, label: option })),
    [routeTypeOptions],
  );

  return (
    <div className="flex flex-col gap-3 flex-1">
      <p className="text-sm text-gray-500">
        {t("smartSurveyor.routesCreation.chooseGroup")}
      </p>
      <div className="space-y-1.5">
        <span className="text-sm text-gray-700 font-medium">
          {t("smartSurveyor.routesCreation.routeTypeField")}
        </span>
        <Select
          multiline
          value={selectedRouteTypeName}
          onChange={onRouteTypeNameChange}
          options={selectOptions}
          placeholder={t("smartSurveyor.routesCreation.groupPlaceholder")}
        />
      </div>
      <Button
        variant="primary"
        className="w-full"
        disabled={!isRouteTypeSelected}
        onClick={onStartDrawing}
      >
        {t("smartSurveyor.routesCreation.startDrawing")}
      </Button>
    </div>
  );
};
